var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('section',{staticClass:"about-page"},[_c('div',{staticClass:"img-holder"},[(_vm.content.image)?_c('img',{attrs:{"src":_vm.content.image.src,"alt":"about-hero-image"}}):_vm._e()]),_vm._v(" "),_c('aboutContent',{attrs:{"content":_vm.content,"title":_vm.title}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }